// extracted by mini-css-extract-plugin
module.exports = {"heading":"az_tt","mediumFont":"az_ut","heavyFont":"az_vt","underline":"az_wt","staticPostType":"az_xt"};